module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-6001HD_white-0fd14c1d3459d5d34026eabe6734bee4.png";